import { render, staticRenderFns } from "./SkinAvatar.vue?vue&type=template&id=6bf0836e&scoped=true&"
import script from "./SkinAvatar.vue?vue&type=script&lang=ts&"
export * from "./SkinAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf0836e",
  null
  
)

export default component.exports